window.pincodeCityData = {
  "560001": "Bangalore",
  "110001": "Central Delhi",
  "400001": "Mumbai",
  "700001": "Kolkata",
  "600001": "Chennai",
  "500001": "Hyderabad",
  "122001": "Gurgaon",
  "201301": "Gautam Buddha Nagar",
  "380001": "Ahmedabad",
  "411001": "Pune",
  "110002": "Central Delhi",
  "110003": "South Delhi",
  "110005": "Central Delhi",
  "110006": "North Delhi",
  "110007": "North Delhi",
  "110008": "Central Delhi",
  "110009": "North West Delhi",
  "110010": "South West Delhi",
  "110011": "Central Delhi",
  "110012": "Central Delhi",
  "110013": "South Delhi",
  "110014": "South Delhi",
  "110015": "West Delhi",
  "110016": "South West Delhi",
  "110017": "South Delhi",
  "110018": "West Delhi",
  "110019": "Delhi",
  "110021": "South West Delhi",
  "110022": "South West Delhi",
  "110023": "South West Delhi",
  "110024": "South Delhi",
  "110025": "South Delhi",
  "110026": "West Delhi",
  "110027": "West Delhi",
  "110028": "South West Delhi",
  "110029": "South West Delhi",
  "110030": "South West Delhi",
  "110031": "East Delhi",
  "110032": "East Delhi",
  "110033": "North West Delhi",
  "110034": "North West Delhi",
  "110035": "North West Delhi",
  "110036": "North West Delhi",
  "110037": "South West Delhi",
  "110038": "South West Delhi",
  "110041": "West Delhi",
  "110044": "South Delhi",
  "110045": "South West Delhi",
  "110046": "South West Delhi",
  "110048": "South Delhi",
  "110049": "South Delhi",
  "110051": "East Delhi",
  "110052": "North West Delhi",
  "110054": "North Delhi",
  "110056": "North West Delhi",
  "110057": "South West Delhi",
  "110058": "West Delhi",
  "110059": "West Delhi",
  "110060": "Central Delhi",
  "110061": "South West Delhi",
  "110063": "West Delhi",
  "110064": "South West Delhi",
  "110065": "South Delhi",
  "110067": "South West Delhi",
  "110068": "South West Delhi",
  "110070": "South West Delhi",
  "110073": "South West Delhi",
  "110075": "South West Delhi",
  "110076": "South Delhi",
  "110077": "South West Delhi",
  "110078": "South West Delhi",
  "110081": "North West Delhi",
  "110083": "North West Delhi",
  "110084": "North Delhi",
  "110085": "North West Delhi",
  "110087": "West Delhi",
  "110088": "North West Delhi",
  "110089": "North West Delhi",
  "110091": "East Delhi",
  "110092": "East Delhi",
  "110095": "East Delhi",
  "110096": "East Delhi",
  "121001": "Faridabad",
  "121002": "Faridabad",
  "121003": "Faridabad",
  "121004": "Faridabad",
  "121007": "Faridabad",
  "121008": "Faridabad",
  "122002": "Gurgaon",
  "122003": "Gurgaon",
  "122004": "Gurgaon",
  "122005": "Gurgaon",
  "122006": "Gurgaon",
  "122007": "Gurgaon",
  "122008": "Gurgaon",
  "122009": "Gurgaon",
  "122010": "Gurgaon",
  "122011": "Gurgaon",
  "122016": "Gurgaon",
  "122017": "Gurgaon",
  "122018": "Gurgaon",
  "122022": "Gurugram",
  "122051": "Gurgaon",
  "122101": "Gurgaon",
  "122102": "Gurgaon",
  "122103": "Gurgaon",
  "122104": "Gurgaon",
  "122505": "Gurgaon",
  "123001": "Mahendragarh",
  "123106": "Rewari",
  "124001": "Rohtak",
  "124103": "Jhajjar",
  "124146": "Jhajjar",
  "124507": "Jhajjar",
  "125001": "Hisar",
  "125005": "Hisar",
  "125006": "Hisar",
  "125076": "Sirsa",
  "125102": "Sirsa",
  "125120": "Fatehabad",
  "125201": "Sirsa",
  "126102": "Jind",
  "127021": "Bhiwani",
  "131001": "Sonipat",
  "132001": "Karnal",
  "132041": "Karnal",
  "132101": "Panipat",
  "132103": "Panipat",
  "132104": "Panipat",
  "132105": "Panipat",
  "132114": "Karnal",
  "132122": "Panipat",
  "133001": "Ambala",
  "133104": "Ambala",
  "134102": "Panchkula",
  "134109": "Panchkula",
  "134113": "Panchkula",
  "134116": "Panchkula",
  "134203": "Ambala",
  "135001": "Yamuna Nagar",
  "135003": "Yamuna Nagar",
  "135133": "Yamuna Nagar",
  "136027": "Kaithal",
  "136118": "Kurukshetra",
  "140001": "Rupnagar",
  "140301": "Mohali",
  "140306": "Mohali",
  "140307": "Rupnagar",
  "140308": "Rupnagar",
  "140406": "Fatehgarh Sahib",
  "140413": "Rupnagar",
  "140603": "Mohali",
  "141001": "Ludhiana",
  "141002": "Ludhiana",
  "141007": "Ludhiana",
  "141012": "Ludhiana",
  "141114": "Ludhiana",
  "141401": "Ludhiana",
  "142001": "Moga",
  "142022": "Ludhiana",
  "142026": "Ludhiana",
  "143001": "Amritsar",
  "143114": "Amritsar",
  "143202": "Amritsar",
  "144002": "Jalandhar",
  "144008": "Jalandhar",
  "144009": "Jalandhar",
  "144026": "Jalandhar",
  "144041": "Jalandhar",
  "144207": "Hoshiarpur",
  "144401": "Kapurthala",
  "144410": "Jalandhar",
  "144411": "Kapurthala",
  "144514": "Nawanshahr",
  "144527": "Hoshiarpur",
  "144533": "Nawanshahr",
  "145001": "PATHANKOT",
  "146105": "Hoshiarpur",
  "146112": "Hoshiarpur",
  "147001": "Patiala",
  "147002": "Patiala",
  "147201": "Patiala",
  "148024": "Sangrur",
  "148028": "Sangrur",
  "148101": "Barnala",
  "151001": "Bathinda",
  "151204": "Faridkot",
  "151503": "Mansa",
  "151505": "Mansa",
  "152002": "Firozpur",
  "152024": "Firozpur",
  "152026": "Muktsar",
  "152116": "Firozpur",
  "152123": "Firozpur",
  "160003": "Chandigarh",
  "160011": "Chandigarh",
  "160012": "Chandigarh",
  "160015": "Chandigarh",
  "160020": "Chandigarh",
  "160022": "Chandigarh",
  "160035": "Chandigarh",
  "160036": "Chandigarh",
  "160047": "Chandigarh",
  "160055": "Mohali",
  "160059": "Rupnagar",
  "160062": "Mohali",
  "160104": "Mohali",
  "171001": "Shimla",
  "171005": "Shimla",
  "171006": "Shimla",
  "172001": "Shimla",
  "172023": "Kullu",
  "172201": "Shimla",
  "173025": "Sirmaur",
  "173205": "Solan",
  "173212": "Solan",
  "173217": "Shimla",
  "174001": "Bilaspur",
  "174021": "Bilaspur",
  "175001": "Mandi",
  "175019": "Mandi",
  "175103": "Kullu",
  "175131": "Kullu",
  "175136": "Kullu",
  "176061": "Kangra",
  "176063": "Kangra",
  "176219": "Kangra",
  "176225": "Kangra",
  "177001": "Hamirpur",
  "177213": "Una",
  "177401": "Hamirpur",
  "180001": "Jammu",
  "180002": "Jammu",
  "180004": "Jammu",
  "180005": "Jammu",
  "180010": "Jammu",
  "181101": "Jammu",
  "181132": "Jammu",
  "181221": "Jammu",
  "182101": "Udhampur",
  "182320": "Reasi",
  "184143": "Kathua",
  "190004": "Srinagar",
  "190008": "Srinagar",
  "190011": "Srinagar",
  "191113": "Budgam",
  "192101": "Ananthnag",
  "192122": "Ananthnag",
  "192129": "Ananthnag",
  "192231": "Ananthnag",
  "192301": "Pulwama",
  "193201": "Baramulla",
  "194101": "Leh",
  "194104": "Leh",
  "201002": "Ghaziabad",
  "201007": "Ghaziabad",
  "201009": "Ghaziabad",
  "201010": "Ghaziabad",
  "201011": "Ghaziabad",
  "201012": "Ghaziabad",
  "201014": "Ghaziabad",
  "201016": "Ghaziabad",
  "201017": "Ghaziabad",
  "201206": "Ghaziabad",
  "201303": "Gautam Buddha Nagar",
  "201304": "Gautam Buddha Nagar",
  "201305": "Gautam Buddha Nagar",
  "201306": "Gautam Buddha Nagar",
  "201307": "Noida",
  "201308": "Greater Noida",
  "201309": "Gautam Buddha Nagar",
  "201310": "Gautam Buddha Nagar",
  "201316": "noida",
  "201318": "Gautam Buddha Nagar",
  "202281": "Aligarh",
  "203001": "Bulandshahr",
  "203207": "Gautam Buddha Nagar",
  "204101": "Hathras",
  "206001": "Etawah",
  "207001": "Etah",
  "207123": "Etah",
  "208001": "Kanpur Nagar",
  "208002": "Kanpur Nagar",
  "208010": "Kanpur Nagar",
  "208011": "Kanpur Nagar",
  "208012": "Kanpur Nagar",
  "208016": "Kanpur Nagar",
  "208025": "Kanpur Nagar",
  "208026": "Kanpur Nagar",
  "209217": "Kanpur Nagar",
  "210001": "Banda",
  "211001": "Allahabad",
  "211002": "Allahabad",
  "211003": "Allahabad",
  "211004": "Allahabad",
  "211005": "Allahabad",
  "211006": "Allahabad",
  "211008": "Allahabad",
  "211010": "Allahabad",
  "211013": "Allahabad",
  "211016": "Allahabad",
  "212502": "Allahabad",
  "212601": "Fatehpur",
  "212635": "Fatehpur",
  "212641": "Fatehpur",
  "212655": "Fatehpur",
  "221001": "Varanasi",
  "221002": "Varanasi",
  "221005": "Varanasi",
  "221010": "Varanasi",
  "221011": "Varanasi",
  "221106": "Varanasi",
  "221108": "Varanasi",
  "223101": "Jaunpur",
  "224001": "Faizabad",
  "224190": "Ambedkar Nagar",
  "225001": "Barabanki",
  "226001": "Lucknow",
  "226002": "Lucknow",
  "226006": "Lucknow",
  "226007": "Lucknow",
  "226008": "Lucknow",
  "226010": "Lucknow",
  "226013": "Lucknow",
  "226015": "Lucknow",
  "226016": "Lucknow",
  "226017": "Lucknow",
  "226021": "Lucknow",
  "226024": "Lucknow",
  "226025": "Lucknow",
  "226401": "Lucknow",
  "229001": "Raebareli",
  "229206": "Raebareli",
  "229410": "Pratapgarh",
  "229841": "Unnao",
  "242001": "Shahjahanpur",
  "242221": "Shahjahanpur",
  "243001": "Bareilly",
  "243006": "Bareilly",
  "243122": "Bareilly",
  "243202": "Bareilly",
  "243601": "Budaun",
  "243639": "Budaun",
  "244001": "Moradabad",
  "244221": "Jyotiba Phule Nagar",
  "244222": "Jyotiba Phule Nagar",
  "244713": "Udham Singh Nagar",
  "244715": "Nainital",
  "244921": "Rampur",
  "245101": "Ghaziabad",
  "245304": "Ghaziabad",
  "246001": "Pauri Garhwal",
  "246429": "Chamoli",
  "246725": "Bijnor",
  "246746": "Bijnor",
  "246747": "Bijnor",
  "247001": "Saharanpur",
  "247667": "Haridwar",
  "247776": "Muzaffarnagar",
  "248001": "Dehradun",
  "248002": "Dehradun",
  "248005": "Dehradun",
  "248006": "Dehradun",
  "248007": "Dehradun",
  "248008": "Dehradun",
  "248009": "Dehradun",
  "248125": "Dehradun",
  "248140": "Dehradun",
  "248142": "Dehradun",
  "248179": "Dehradun",
  "249201": "Dehradun",
  "249202": "Dehradun",
  "249204": "Dehradun",
  "249205": "Dehradun",
  "249401": "Haridwar",
  "249403": "Haridwar",
  "249407": "Haridwar",
  "249408": "Haridwar",
  "249410": "Haridwar",
  "250001": "Meerut",
  "250002": "Meerut",
  "250005": "Meerut",
  "251001": "Muzaffarnagar",
  "262122": "Pilibhit",
  "262405": "Udham Singh Nagar",
  "262501": "Pithoragarh",
  "262524": "Champawat",
  "263136": "Nainital",
  "263139": "Nainital",
  "263153": "Udham Singh Nagar",
  "263601": "Almora",
  "271801": "Bahraich",
  "272153": "Bansi",
  "272192": "Siddharthnagar",
  "273001": "Gorakhpur",
  "273007": "Gorakhpur",
  "273016": "Gorakhpur",
  "273158": "Gorakhpur",
  "273409": "Gorakhpur",
  "273413": "Gorakhpur",
  "274206": "Kushinagar",
  "275101": "Mau",
  "276406": "Azamgarh",
  "281001": "Mathura",
  "281121": "Mathura",
  "281123": "Mathura",
  "281403": "Mathura",
  "281502": "Mathura",
  "282001": "Agra",
  "282002": "Agra",
  "282005": "Agra",
  "283201": "Agra",
  "283203": "Firozabad",
  "284001": "Jhansi",
  "284003": "Jhansi",
  "284128": "Jhansi",
  "285001": "Jalaun",
  "301001": "Alwar",
  "301019": "Alwar",
  "301020": "Alwar",
  "302001": "Jaipur",
  "302002": "Jaipur",
  "302004": "Jaipur",
  "302005": "Jaipur",
  "302006": "Jaipur",
  "302012": "Jaipur",
  "302015": "Jaipur",
  "302016": "Jaipur",
  "302017": "Jaipur",
  "302018": "Jaipur",
  "302019": "Jaipur",
  "302020": "Jaipur",
  "302021": "Jaipur",
  "302022": "Jaipur",
  "302023": "Jaipur",
  "302026": "Jaipur",
  "302029": "Jaipur",
  "302033": "Jaipur",
  "302034": "Jaipur",
  "302039": "Jaipur",
  "303002": "Jaipur",
  "303801": "Jaipur",
  "305001": "Ajmer",
  "305004": "Ajmer",
  "305022": "Ajmer",
  "305401": "Ajmer",
  "305404": "Ajmer",
  "305801": "Ajmer",
  "305901": "Ajmer",
  "306023": "Pali",
  "306115": "Pali",
  "306401": "Pali",
  "306708": "Pali",
  "306902": "Pali",
  "307026": "Sirohi",
  "307510": "Sirohi",
  "307801": "Sirohi",
  "311001": "Bhilwara",
  "313001": "Udaipur",
  "313002": "Udaipur",
  "313324": "Rajsamand",
  "313332": "Rajsamand",
  "314035": "Dungarpur",
  "322001": "Sawai Madhopur",
  "322241": "Karauli",
  "323307": "Chittorgarh",
  "324001": "Kota",
  "324005": "Kota",
  "324007": "Kota",
  "324008": "Kota",
  "324009": "Kota",
  "325201": "Kota",
  "327001": "Banswara",
  "331001": "Churu",
  "331023": "Churu",
  "332001": "Sikar",
  "333001": "Jhujhunu",
  "333031": "Jhujhunu",
  "333041": "Jhujhunu",
  "334001": "Bikaner",
  "334003": "Bikaner",
  "335001": "Ganganagar",
  "335513": "Hanumangarh",
  "341001": "Nagaur",
  "341508": "Nagaur",
  "342001": "Jodhpur",
  "342002": "Jodhpur",
  "342005": "Jodhpur",
  "342006": "Jodhpur",
  "342008": "Jodhpur",
  "342301": "Jodhpur",
  "342304": "Jodhpur",
  "343022": "Jalor",
  "344001": "Barmer",
  "344022": "Balotra",
  "344024": "Barmer",
  "360001": "Rajkot",
  "360002": "Rajkot",
  "360004": "Rajkot",
  "360005": "Rajkot",
  "360007": "Rajkot",
  "360021": "Rajkot",
  "360024": "Rajkot",
  "360370": "Rajkot",
  "360410": "Rajkot",
  "360578": "Porbandar",
  "360611": "Gondal",
  "361004": "Jamnagar",
  "361005": "Jamnagar",
  "361006": "Jamnagar",
  "361008": "Jamnagar",
  "361210": "Jamnagar",
  "361306": "Jamnagar",
  "362001": "Junagadh",
  "362015": "Junagadh",
  "362560": "Junagadh",
  "363001": "Surendra Nagar",
  "363641": "Morbi district",
  "364001": "Bhavnagar",
  "364002": "Bhavnagar",
  "365601": "Amreli",
  "370001": "Kachchh",
  "370020": "Kachchh",
  "370110": "Kachchh",
  "370201": "Kachchh",
  "370203": "Kachchh",
  "370421": "Kachchh",
  "370460": "Kachchh",
  "370469": "Mandvi",
  "380004": "Ahmedabad",
  "380005": "Ahmedabad",
  "380006": "Ahmedabad",
  "380007": "Ahmedabad",
  "380008": "Ahmedabad",
  "380009": "Ahmedabad",
  "380013": "Ahmedabad",
  "380015": "Ahmedabad",
  "380016": "Ahmedabad",
  "380050": "Ahmedabad",
  "380051": "Ahmedabad",
  "380052": "Ahmedabad",
  "380054": "Ahmedabad",
  "380058": "Ahmedabad",
  "380059": "Ahmedabad",
  "380060": "Ahmedabad",
  "380061": "Ahmedabad",
  "382007": "Gandhi Nagar",
  "382016": "Gandhi Nagar",
  "382110": "Ahmedabad",
  "382115": "Ahmedabad",
  "382210": "Ahmedabad",
  "382225": "Ahmedabad",
  "382330": "Ahmedabad",
  "382355": "Gandhi Nagar",
  "382415": "Ahmedabad",
  "382421": "Gandhi Nagar",
  "382426": "Ahmedabad",
  "382430": "Ahmedabad",
  "382443": "Ahmedabad",
  "382445": "Ahmedabad",
  "382470": "Ahmedabad",
  "382475": "Ahmedabad",
  "382480": "Ahmedabad",
  "382481": "Ahmedabad",
  "383307": "Sabarkantha",
  "383310": "Sabarkantha",
  "384002": "Mahesana",
  "384170": "Mahesana",
  "384315": "Mahesana",
  "385001": "Banaskantha",
  "385535": "Banaskantha",
  "387001": "Kheda",
  "387002": "Kheda",
  "388001": "Anand",
  "388120": "Anand",
  "388121": "Anand",
  "388325": "Anand",
  "389170": "Dahod",
  "389350": "Panch Mahals",
  "390001": "Vadodara",
  "390002": "Vadodara",
  "390003": "Vadodara",
  "390007": "Vadodara",
  "390010": "Vadodara",
  "390012": "Vadodara",
  "390013": "Vadodara",
  "390016": "Vadodara",
  "390018": "Vadodara",
  "390019": "Vadodara",
  "390020": "Vadodara",
  "390021": "Vadodara",
  "390023": "Vadodara",
  "390024": "Vadodara",
  "391243": "Vadodara",
  "391410": "Vadodara",
  "391740": "Vadodara",
  "392001": "Bharuch",
  "392011": "Bharuch",
  "392012": "Bharuch",
  "392015": "Bharuch",
  "392130": "Bharuch",
  "392135": "Bharuch",
  "393001": "Bharuch",
  "393002": "Ankleshwar",
  "394130": "Surat",
  "394155": "Surat",
  "394510": "Surat",
  "394601": "Surat",
  "394630": "Surat",
  "394650": "Surat",
  "395001": "Surat",
  "395002": "Surat",
  "395003": "Surat",
  "395004": "Surat",
  "395005": "Surat",
  "395006": "Surat",
  "395007": "Surat",
  "395009": "Surat",
  "395010": "Surat",
  "395017": "Surat",
  "396001": "Valsad",
  "396020": "Valsad",
  "396035": "Valsad",
  "396060": "Navsari",
  "396125": "Valsad",
  "396155": "Valsad",
  "396171": "Valsad",
  "396191": "Valsad",
  "396210": "Daman",
  "396321": "Navsari",
  "396445": "Navsari",
  "400002": "Mumbai",
  "400003": "Mumbai",
  "400004": "Mumbai",
  "400005": "Mumbai",
  "400006": "Mumbai",
  "400007": "Mumbai",
  "400008": "Mumbai",
  "400009": "Mumbai",
  "400011": "Mumbai",
  "400012": "Mumbai",
  "400013": "Mumbai",
  "400014": "Mumbai",
  "400015": "Mumbai",
  "400016": "Mumbai",
  "400018": "Mumbai",
  "400019": "Mumbai",
  "400022": "Mumbai",
  "400024": "Mumbai",
  "400025": "Mumbai",
  "400026": "Mumbai",
  "400027": "Mumbai",
  "400028": "Mumbai",
  "400029": "Mumbai",
  "400030": "Mumbai",
  "400031": "Mumbai",
  "400034": "Mumbai",
  "400036": "Mumbai",
  "400037": "Mumbai",
  "400042": "Mumbai",
  "400043": "Mumbai",
  "400049": "Mumbai",
  "400050": "Mumbai",
  "400051": "Mumbai",
  "400052": "Mumbai",
  "400053": "Mumbai",
  "400054": "Mumbai",
  "400055": "Mumbai",
  "400056": "Mumbai",
  "400057": "Mumbai",
  "400058": "Mumbai",
  "400059": "Mumbai",
  "400060": "Mumbai",
  "400061": "Mumbai",
  "400062": "Mumbai",
  "400063": "Mumbai",
  "400064": "Mumbai",
  "400066": "Mumbai",
  "400067": "Mumbai",
  "400068": "Mumbai",
  "400069": "Mumbai",
  "400070": "Mumbai",
  "400071": "Mumbai",
  "400072": "Mumbai",
  "400074": "Mumbai",
  "400075": "Mumbai",
  "400076": "Mumbai",
  "400077": "Mumbai",
  "400078": "Mumbai",
  "400079": "Mumbai",
  "400080": "Mumbai",
  "400081": "Mumbai",
  "400082": "Mumbai",
  "400083": "Mumbai",
  "400086": "Mumbai",
  "400088": "Mumbai",
  "400089": "Mumbai",
  "400091": "Mumbai",
  "400092": "Mumbai",
  "400093": "Mumbai",
  "400094": "Mumbai",
  "400095": "Mumbai",
  "400097": "Mumbai",
  "400098": "Mumbai",
  "400099": "Mumbai",
  "400101": "Mumbai",
  "400102": "Mumbai",
  "400103": "Mumbai",
  "400104": "Mumbai",
  "400601": "Thane",
  "400602": "Thane",
  "400604": "Thane",
  "400605": "Thane",
  "400606": "Thane",
  "400607": "Thane",
  "400608": "Thane",
  "400610": "Thane",
  "400612": "Thane",
  "400614": "Thane",
  "400615": "Thane",
  "400701": "Thane",
  "400702": "Raigarh",
  "400703": "Thane",
  "400704": "Raigarh",
  "400705": "Thane",
  "400706": "Thane",
  "400708": "Thane",
  "400709": "Thane",
  "401101": "Thane",
  "401105": "Thane",
  "401107": "Thane",
  "401201": "Thane",
  "401202": "Thane",
  "401203": "Thane",
  "401207": "Thane",
  "401208": "Thane",
  "401209": "Thane",
  "401301": "Thane",
  "401303": "Thane",
  "401305": "Thane",
  "401404": "Thane",
  "401501": "Thane",
  "401504": "Thane",
  "402107": "Raigarh",
  "402125": "Raigarh",
  "403001": "North Goa",
  "403002": "North Goa",
  "403004": "North Goa",
  "403114": "North Goa",
  "403401": "South Goa",
  "403404": "South Goa",
  "403406": "North Goa",
  "403502": "North Goa",
  "403504": "North Goa",
  "403505": "North Goa",
  "403507": "North Goa",
  "403510": "North Goa",
  "403512": "North Goa",
  "403521": "North Goa",
  "403601": "South Goa",
  "403602": "South Goa",
  "403604": "South Goa",
  "403702": "South Goa",
  "403706": "South Goa",
  "403707": "South Goa",
  "403711": "South Goa",
  "403713": "South Goa",
  "403715": "South Goa",
  "403718": "South Goa",
  "403722": "South Goa",
  "403726": "South Goa",
  "410015": "Pune",
  "410203": "Raigarh",
  "410206": "Navi Mumbai",
  "410208": "Raigarh",
  "410209": "Kamothe",
  "410210": "Raigarh",
  "410221": "Raigarh",
  "410501": "Pune",
  "410505": "Pune",
  "410506": "Pune",
  "411002": "Pune",
  "411004": "Pune",
  "411005": "Pune",
  "411006": "Pune",
  "411007": "Pune",
  "411008": "Pune",
  "411009": "Pune",
  "411011": "Pune",
  "411013": "Pune",
  "411014": "Pune",
  "411015": "Pune",
  "411016": "Pune",
  "411017": "Pune",
  "411018": "Pune",
  "411019": "Pune",
  "411020": "Pune",
  "411021": "Pune",
  "411026": "Pune",
  "411027": "Pune",
  "411028": "Pune",
  "411030": "Pune",
  "411032": "Pune",
  "411033": "Pune",
  "411035": "Pune",
  "411036": "Pune",
  "411037": "Pune",
  "411038": "Pune",
  "411039": "Pune",
  "411040": "Pune",
  "411041": "Pune",
  "411043": "Pune",
  "411045": "Pune",
  "411046": "Pune",
  "411047": "Pune",
  "411048": "Pune",
  "411051": "Pune",
  "411052": "Pune",
  "411057": "Pune",
  "411058": "Pune",
  "411060": "Pune",
  "411061": "Pune",
  "411062": "Pune",
  "411067": "Pune",
  "412101": "Pune",
  "412102": "Pune",
  "412105": "Pune",
  "412106": "Pune",
  "412110": "Pune",
  "412112": "Pune",
  "412115": "Pune",
  "412207": "Pune",
  "412301": "Pune",
  "412307": "Pune",
  "412308": "Pune",
  "412805": "Satara",
  "413003": "Solapur",
  "413006": "Solapur",
  "413102": "Pune",
  "413113": "Solapur",
  "413114": "Pune",
  "413219": "Solapur",
  "413227": "Solapur",
  "413255": "Solapur",
  "413304": "Solapur",
  "413401": "Solapur",
  "413512": "Latur",
  "413515": "Latur",
  "413517": "Latur",
  "413531": "Latur",
  "413709": "Ahmed Nagar",
  "413736": "Ahmed Nagar",
  "414001": "Ahmed Nagar",
  "414003": "Ahmed Nagar",
  "414111": "Ahmed Nagar",
  "415002": "Satara",
  "415110": "Satara",
  "415604": "Ratnagiri",
  "415605": "Ratnagiri",
  "415612": "Ratnagiri",
  "415709": "Ratnagiri",
  "415804": "Ratnagiri",
  "416002": "Kolhapur",
  "416003": "Kolhapur",
  "416005": "Kolhapur",
  "416007": "Kolhapur",
  "416008": "Kolhapur",
  "416012": "Kolhapur",
  "416013": "Kolhapur",
  "416101": "Kolhapur",
  "416115": "Kolhapur",
  "416306": "Sangli",
  "416310": "Sangli",
  "416402": "Sangli",
  "416404": "Sangli",
  "416410": "Sangli",
  "416415": "Sangli",
  "416416": "Sangli",
  "416518": "Sindhudurg",
  "416520": "Sindhudurg",
  "416602": "Sindhudurg",
  "416702": "Ratnagiri",
  "421002": "Thane",
  "421003": "Mumbai",
  "421004": "Thane",
  "421102": "Thane",
  "421201": "Thane",
  "421202": "Thane",
  "421203": "Thane",
  "421204": "Thane",
  "421301": "Thane",
  "421302": "Thane",
  "421306": "Thane",
  "421311": "Thane",
  "421501": "Thane",
  "421503": "Thane",
  "421505": "Thane",
  "421605": "Thane",
  "422001": "Nashik",
  "422003": "Nashik",
  "422005": "Nashik",
  "422006": "Nashik",
  "422007": "Nashik",
  "422008": "Nashik",
  "422009": "Nashik",
  "422010": "Nashik",
  "422011": "Nashik",
  "422013": "Nashik",
  "422101": "Nashik",
  "422207": "Nashik",
  "422401": "Nashik",
  "422601": "Ahmed Nagar",
  "423203": "Nashik",
  "423401": "Nashik",
  "423601": "Ahmed Nagar",
  "424001": "Dhule",
  "425001": "Jalgaon",
  "425002": "Jalgaon",
  "425003": "Jalgaon",
  "425201": "Jalgaon",
  "425412": "Nandurbar",
  "431001": "Aurangabad",
  "431002": "Aurangabad",
  "431005": "Aurangabad",
  "431009": "Aurangabad",
  "431010": "Aurangabad",
  "431122": "Beed",
  "431136": "Aurangabad",
  "431203": "Jalna",
  "431401": "Parbhani",
  "431515": "Beed",
  "431601": "Nanded",
  "431605": "Nanded",
  "431806": "Nanded",
  "440006": "Nagpur",
  "440007": "Nagpur",
  "440008": "Nagpur",
  "440010": "Nagpur",
  "440012": "Nagpur",
  "440013": "Nagpur",
  "440016": "Nagpur",
  "440022": "Nagpur",
  "440026": "Nagpur",
  "440027": "Nagpur",
  "440030": "Nagpur",
  "440032": "Nagpur",
  "440034": "Nagpur",
  "440035": "Nagpur",
  "441108": "Nagpur",
  "441110": "Nagpur",
  "441614": "Gondia",
  "441702": "Gondia",
  "442102": "Wardha",
  "442203": "Wardha",
  "442301": "Wardha",
  "442401": "Chandrapur",
  "442402": "Chandrapur",
  "442403": "Chandrapur",
  "443001": "Buldhana",
  "443101": "Buldhana",
  "444001": "Akola",
  "444004": "Akola",
  "444005": "Akola",
  "444505": "Washim",
  "444601": "Amravati",
  "444603": "Amravati",
  "444604": "Amravati",
  "444701": "Amravati",
  "444805": "Amravati",
  "445001": "Yavatmal",
  "445203": "Yavatmal",
  "445204": "Yavatmal",
  "445302": "Yavatmal",
  "445305": "Yavatmal",
  "450001": "East Nimar",
  "451221": "West Nimar",
  "451335": "West Nimar",
  "451551": "Barwani",
  "452001": "Indore",
  "452003": "Indore",
  "452005": "Indore",
  "452007": "Indore",
  "452009": "Indore",
  "452010": "Indore",
  "452012": "Indore",
  "452013": "Indore",
  "452016": "Indore",
  "452018": "Indore",
  "452020": "Indore",
  "453552": "INDORE",
  "453555": "Indore",
  "453556": "Indore",
  "454001": "Dhar",
  "454446": "Dhar",
  "455001": "Dewas",
  "456001": "Ujjain",
  "456006": "Ujjain",
  "456010": "Ujjain",
  "456335": "Ujjain",
  "456771": "Ujjain",
  "457001": "Ratlam",
  "457226": "Ratlam",
  "458001": "Mandsaur",
  "458002": "Mandsaur",
  "458441": "Neemuch",
  "461001": "Hoshangabad",
  "461775": "Hoshangabad",
  "462001": "Bhopal",
  "462003": "Bhopal",
  "462007": "Bhopal",
  "462011": "Bhopal",
  "462016": "Bhopal",
  "462022": "Bhopal",
  "462023": "Bhopal",
  "462024": "Bhopal",
  "462026": "Bhopal",
  "462030": "Bhopal",
  "462038": "Bhopal",
  "462039": "Bhopal",
  "462042": "Bhopal",
  "462043": "Bhopal",
  "462046": "Bhopal",
  "462047": "Bhopal",
  "462066": "Bhopal",
  "466114": "Sehore",
  "470002": "Sagar",
  "470004": "Sagar",
  "470661": "Damoh",
  "471001": "Chhatarpur",
  "471606": "Chhatarpur",
  "472001": "Tikamgarh",
  "472246": "Tikamgarh",
  "472336": "Tikamgarh",
  "473001": "Guna",
  "473551": "Shivpuri",
  "474003": "Gwalior",
  "474004": "Gwalior",
  "474006": "Gwalior",
  "474011": "Gwalior",
  "480001": "Chhindwara",
  "480991": "Seoni",
  "482001": "Jabalpur",
  "482002": "Jabalpur",
  "482003": "Jabalpur",
  "482004": "Jabalpur",
  "482005": "Jabalpur",
  "482008": "Jabalpur",
  "482021": "Jabalpur",
  "483501": "Katni",
  "483504": "Katni",
  "484114": "Shahdol",
  "484886": "Anuppur",
  "485001": "Satna",
  "486001": "Rewa",
  "486885": "Singrauli",
  "486890": "Sidhi",
  "490001": "Durg",
  "490006": "Durg",
  "490020": "Durg",
  "490023": "Durg",
  "490024": "Durg",
  "490026": "Durg",
  "491001": "Durg",
  "491111": "Durg",
  "491441": "Rajnandgaon",
  "491666": "Rajnandgaon",
  "492001": "Raipur",
  "492004": "Raipur",
  "492007": "Raipur",
  "492009": "Raipur",
  "492010": "Raipur",
  "492013": "Raipur",
  "492014": "Raipur",
  "492099": "Raipur",
  "493225": "Raipur",
  "493445": "Mahasamund",
  "493554": "Mahasamund",
  "493773": "Dhamtari",
  "493881": "Raipur",
  "494001": "Bastar",
  "494444": "Bijapur(CGH)",
  "494556": "Dantewada",
  "495001": "Bilaspur(CGH)",
  "495004": "Bilaspur(CGH)",
  "495006": "Bilaspur(CGH)",
  "495220": "Bilaspur(CGH)",
  "495334": "Bilaspur(CGH)",
  "495450": "Korba",
  "495677": "Korba",
  "495678": "Korba",
  "496001": "Raigarh",
  "496005": "Raigarh",
  "496111": "Raigarh",
  "496118": "Jashpur",
  "497001": "Surguja",
  "497442": "Koriya",
  "500002": "Hyderabad",
  "500003": "Hyderabad",
  "500004": "Hyderabad",
  "500008": "Hyderabad",
  "500009": "Hyderabad",
  "500010": "Hyderabad",
  "500011": "Hyderabad",
  "500012": "Hyderabad",
  "500013": "Hyderabad",
  "500014": "Hyderabad",
  "500015": "Hyderabad",
  "500016": "Hyderabad",
  "500017": "Hyderabad",
  "500018": "K.V.Rangareddy",
  "500019": "K.V.Rangareddy",
  "500020": "Hyderabad",
  "500023": "Hyderabad",
  "500026": "Hyderabad",
  "500027": "Hyderabad",
  "500029": "Hyderabad",
  "500030": "K.V.Rangareddy",
  "500032": "K.V.Rangareddy",
  "500033": "Hyderabad",
  "500034": "Hyderabad",
  "500035": "Hyderabad",
  "500036": "Hyderabad",
  "500037": "Hyderabad",
  "500038": "Hyderabad",
  "500039": "Hyderabad",
  "500040": "Hyderabad",
  "500043": "K.V.Rangareddy",
  "500045": "Hyderabad",
  "500046": "K.V.Rangareddy",
  "500047": "Hyderabad",
  "500048": "K.V.Rangareddy",
  "500049": "Mathrusri Nagar",
  "500050": "Hyderabad",
  "500052": "K.V.Rangareddy",
  "500054": "Hyderabad",
  "500055": "Hyderabad",
  "500056": "Hyderabad",
  "500059": "Hyderabad",
  "500060": "K.V.Rangareddy",
  "500062": "Hyderabad",
  "500063": "Hyderabad",
  "500067": "K.V.Rangareddy",
  "500068": "K.V.Rangareddy",
  "500070": "K.V.Rangareddy",
  "500072": "Hyderabad",
  "500073": "Hyderabad",
  "500074": "K.V.Rangareddy",
  "500075": "K.V.Rangareddy",
  "500076": "K.V.Rangareddy",
  "500079": "K.V.Rangareddy",
  "500080": "Hyderabad",
  "500081": "Hyderabad",
  "500082": "Hyderabad",
  "500083": "K.V.Rangareddy",
  "500084": "K.V.Rangareddy",
  "500085": "Hyderabad",
  "500087": "Hyderabad",
  "500089": "HYDERABAD",
  "500090": "K.V.Rangareddy",
  "500091": "Hyderabad",
  "500096": "Hyderabad",
  "500097": "K.V.Rangareddy",
  "500101": "Hyderabad",
  "501301": "Hyderabad",
  "501505": "K.V.Rangareddy",
  "501510": "K.V.Rangareddy",
  "502032": "Medak",
  "502101": "Medak",
  "502278": "Medak",
  "502285": "Medak",
  "502300": "Medak",
  "503306": "Nizamabad",
  "503311": "Nizamabad",
  "504103": "Adilabad",
  "504208": "Adilabad",
  "505001": "Karim Nagar",
  "505184": "Karim Nagar",
  "505325": "Karim Nagar",
  "506001": "Warangal",
  "506002": "Warangal",
  "506004": "Warangal",
  "506013": "Warangal",
  "507111": "Khammam",
  "507203": "Khammam",
  "508001": "Nalgonda",
  "508213": "Suryapet",
  "509001": "Mahabub Nagar",
  "509152": "Mahabub Nagar",
  "509321": "Mahabub Nagar",
  "515001": "Ananthapur",
  "515005": "Ananthapur",
  "515110": "Ananthapur",
  "515134": "Ananthapur",
  "515402": "Ananthapur",
  "515411": "Ananthapur",
  "515591": "Ananthapur",
  "515766": "Ananthapur",
  "516001": "Cuddapah",
  "516002": "Cuddapah",
  "516003": "Cuddapah",
  "516004": "Cuddapah",
  "516269": "Cuddapah",
  "516360": "Cuddapah",
  "517001": "Chittoor",
  "517124": "Chittoor",
  "517132": "Chittoor",
  "517401": "Chittoor",
  "517424": "Chittoor",
  "517501": "Chittoor",
  "517502": "Chittoor",
  "517506": "Chittoor",
  "517507": "Chittoor",
  "517590": "Chittoor",
  "518001": "Kurnool",
  "518002": "Kurnool",
  "518003": "Kurnool",
  "518004": "Kurnool",
  "518123": "Kurnool",
  "518222": "Kurnool",
  "518422": "Kurnool",
  "518501": "Kurnool",
  "518502": "Kurnool",
  "520001": "Krishna",
  "520002": "Krishna",
  "520004": "Krishna",
  "520007": "Krishna",
  "520008": "Krishna",
  "520010": "Krishna",
  "520012": "Krishna",
  "520013": "Krishna",
  "521002": "Krishna",
  "521102": "Krishna",
  "521105": "Krishna",
  "521108": "Krishna",
  "521134": "Krishna",
  "521137": "Krishna",
  "521185": "Krishna",
  "521225": "Krishna",
  "521456": "Krishna",
  "522001": "Guntur",
  "522002": "Guntur",
  "522006": "Guntur",
  "522007": "Guntur",
  "522034": "Guntur",
  "522201": "Guntur",
  "522202": "Guntur",
  "522213": "Guntur",
  "522237": "Guntur",
  "522265": "Guntur",
  "522413": "Guntur",
  "522502": "Guntur",
  "522503": "Guntur",
  "522601": "Guntur",
  "523001": "Prakasam",
  "523155": "Prakasam",
  "523157": "Prakasam",
  "523241": "Prakasam",
  "523326": "Prakasam",
  "524001": "Nellore",
  "524002": "Nellore",
  "524003": "Nellore",
  "524101": "Nellore",
  "524121": "Nellore",
  "524142": "Nellore",
  "524201": "Nellore",
  "530002": "Visakhapatnam",
  "530003": "Visakhapatnam",
  "530004": "Visakhapatnam",
  "530009": "Visakhapatnam",
  "530011": "Visakhapatnam",
  "530012": "Visakhapatnam",
  "530013": "Visakhapatnam",
  "530017": "Visakhapatnam",
  "530022": "Visakhapatnam",
  "530024": "Visakhapatnam",
  "530027": "Visakhapatnam",
  "530029": "Visakhapatnam",
  "530041": "Visakhapatnam",
  "530045": "Visakhapatnam",
  "530047": "Visakhapatnam",
  "530051": "Visakhapatnam",
  "531173": "Visakhapatnam",
  "532001": "Srikakulam",
  "532127": "Srikakulam",
  "533004": "East Godavari",
  "533005": "East Godavari",
  "533101": "East Godavari",
  "533102": "East Godavari",
  "533103": "East Godavari",
  "533126": "East Godavari",
  "533201": "East Godavari",
  "533238": "East Godavari",
  "533253": "East Godavari",
  "533296": "East Godavari",
  "533450": "East Godavari",
  "534001": "West Godavari",
  "534005": "West Godavari",
  "534007": "West Godavari",
  "534123": "West Godavari",
  "534134": "West Godavari",
  "534201": "West Godavari",
  "534245": "West Godavari",
  "534275": "West Godavari",
  "534326": "West Godavari",
  "535002": "Vizianagaram",
  "535005": "Vizianagaram",
  "560002": "Bangalore",
  "560003": "Bangalore",
  "560004": "Bangalore",
  "560005": "Bangalore",
  "560006": "Bangalore",
  "560008": "Bangalore",
  "560009": "Bangalore",
  "560010": "Bangalore",
  "560011": "Bangalore",
  "560012": "Bangalore",
  "560013": "Bangalore",
  "560014": "Bangalore",
  "560015": "Bangalore",
  "560016": "Bangalore",
  "560017": "Bangalore",
  "560018": "Bangalore",
  "560020": "Bangalore",
  "560021": "Bangalore",
  "560022": "Bangalore",
  "560023": "Bangalore",
  "560024": "Bangalore",
  "560025": "Bangalore",
  "560026": "Bangalore",
  "560027": "Bangalore",
  "560029": "Bangalore",
  "560030": "Bangalore",
  "560032": "Bangalore",
  "560033": "Bangalore",
  "560034": "Bangalore",
  "560035": "Bangalore",
  "560036": "Bangalore",
  "560037": "Bangalore",
  "560038": "Bangalore",
  "560039": "Bangalore",
  "560040": "Bangalore",
  "560041": "Bangalore",
  "560042": "Bangalore",
  "560043": "Bangalore",
  "560045": "Bangalore",
  "560046": "Bangalore",
  "560047": "Bangalore",
  "560048": "Bangalore",
  "560049": "Bangalore",
  "560050": "Bangalore",
  "560052": "Bangalore",
  "560053": "Bangalore",
  "560054": "Bangalore",
  "560055": "Bangalore",
  "560056": "Bangalore",
  "560057": "Bangalore",
  "560058": "Bangalore",
  "560059": "Bangalore",
  "560060": "Bangalore",
  "560061": "Bangalore",
  "560062": "Bangalore",
  "560063": "Bangalore",
  "560064": "Bangalore",
  "560065": "Bangalore",
  "560066": "Bangalore",
  "560067": "Bangalore",
  "560068": "Bangalore",
  "560069": "Bangalore",
  "560070": "Bangalore",
  "560071": "Bangalore",
  "560072": "Bangalore",
  "560073": "Bangalore",
  "560074": "Bangalore",
  "560075": "Bangalore",
  "560076": "Bangalore",
  "560077": "Bangalore",
  "560078": "Bangalore",
  "560079": "Bangalore",
  "560080": "Bangalore",
  "560081": "Bangalore",
  "560082": "Bangalore",
  "560083": "Bangalore",
  "560084": "Bangalore",
  "560085": "Bangalore",
  "560086": "Bangalore",
  "560087": "Bangalore",
  "560088": "Bangalore Rural",
  "560090": "Bangalore Rural",
  "560091": "Bangalore Rural",
  "560092": "Bangalore",
  "560093": "Bangalore",
  "560094": "Bangalore",
  "560095": "Bangalore",
  "560097": "Bangalore",
  "560098": "Bangalore",
  "560099": "Bangalore",
  "560100": "Bangalore",
  "560102": "Bangalore",
  "560103": "Bangalore",
  "560104": "Bangalore",
  "560105": "Bangalore",
  "560108": "Bangalore",
  "560109": "Bangalore",
  "560110": "Bangalore",
  "561101": "Bangalore Rural",
  "561202": "Tumkur",
  "561203": "Bangalore Rural",
  "561208": "Kolar",
  "562103": "Kolar",
  "562106": "Bangalore",
  "562107": "Bangalore",
  "562109": "Ramanagar",
  "562110": "Bangalore Rural",
  "562112": "Ramanagar",
  "562114": "Bangalore Rural",
  "562125": "Bangalore",
  "562130": "Bangalore",
  "562157": "Bangalore",
  "562159": "Ramanagar",
  "562162": "Bangalore Rural",
  "562164": "Channapatna",
  "563114": "Kolar",
  "563122": "Kolar",
  "563130": "Kolar",
  "563131": "Kolar",
  "563138": "Kolar",
  "570001": "Mysore",
  "570002": "Mysore",
  "570004": "Mysore",
  "570008": "Mysore",
  "570009": "Mysore",
  "570011": "Mysore",
  "570015": "Mysore",
  "570016": "Mysore",
  "570017": "Mysore",
  "570018": "Mysore",
  "570019": "Mysore",
  "570022": "Mysore",
  "570023": "Mysore",
  "570026": "Mysore",
  "570028": "Mysore",
  "571110": "Mysore",
  "571111": "Chamrajnagar",
  "571125": "Mysore",
  "571213": "Kodagu",
  "571236": "Kodagu",
  "571249": "Kodagu",
  "571250": "Kodagu",
  "571301": "Mysore",
  "571401": "Mandya",
  "571426": "Mandya",
  "571432": "Mandya",
  "571448": "Mandya",
  "571606": "Mandya",
  "572102": "Tumkur",
  "572103": "Tumkur",
  "572106": "Tumkur",
  "572130": "Tumkur",
  "572132": "Tumkur",
  "572137": "Tumkur",
  "572201": "Tiptur",
  "572216": "Tumkur",
  "573103": "Hassan",
  "573115": "Hassan",
  "573125": "Hassan",
  "573201": "Hassan",
  "573211": "Hassan",
  "574102": "Udupi",
  "574104": "Udupi",
  "574106": "Udupi",
  "574146": "Dakshina Kannada",
  "574150": "Dakshina Kannada",
  "574151": "Dakshina Kannada",
  "574197": "Dakshina Kannada",
  "574201": "Dakshina Kannada",
  "574202": "Dakshina Kannada",
  "574203": "Dakshina Kannada",
  "574210": "Dakshina Kannada",
  "574216": "Dakshina Kannada",
  "574222": "Dakshina Kannada",
  "574227": "Dakshina Kannada",
  "574239": "Dakshina Kannada",
  "574240": "Dakshina Kannada",
  "574241": "Dakshina Kannada",
  "575001": "Dakshina Kannada",
  "575002": "Dakshina Kannada",
  "575003": "Dakshina Kannada",
  "575004": "Dakshina Kannada",
  "575005": "Dakshina Kannada",
  "575006": "Dakshina Kannada",
  "575015": "Dakshina Kannada",
  "575016": "Dakshina Kannada",
  "575019": "Dakshina Kannada",
  "575022": "Dakshina Kannada",
  "575025": "Dakshina Kannada",
  "576101": "Udupi",
  "576102": "Udupi",
  "576103": "Udupi",
  "576104": "Udupi",
  "576111": "Udupi",
  "576201": "Udupi",
  "576210": "Udupi",
  "576217": "Udupi",
  "576221": "Udupi",
  "576228": "Udupi",
  "576234": "Udupi",
  "577001": "Davangere",
  "577004": "Davangere",
  "577006": "Davangere",
  "577101": "Chickmagalur",
  "577102": "Chickmagalur",
  "577112": "Chickmagalur",
  "577139": "Chickmagalur",
  "577201": "Shimoga",
  "577204": "Shimoga",
  "577205": "Shimoga",
  "577301": "Shimoga",
  "577401": "Shimoga",
  "577417": "Shimoga",
  "577422": "Shimoga",
  "577427": "Shimoga",
  "577501": "Chitradurga",
  "577502": "Chitradurga",
  "577511": "Chitradurga",
  "577522": "Chitradurga",
  "577550": "Chickmagalur",
  "577598": "Chitradurga",
  "577601": "Davangere",
  "580001": "Dharwad",
  "580004": "Dharwad",
  "580007": "Dharwad",
  "580008": "Dharwad",
  "580020": "Hubli",
  "580023": "Dharwad",
  "580024": "Dharwad",
  "580028": "Dharwad",
  "580029": "Dharwad",
  "580030": "Hubli",
  "580031": "Dharwad",
  "581115": "Haveri",
  "581301": "Uttara Kannada",
  "581303": "Uttara Kannada",
  "581304": "Uttara Kannada",
  "581306": "Uttara Kannada",
  "581314": "Uttara Kannada",
  "581316": "Uttara Kannada",
  "581320": "Uttara Kannada",
  "581326": "Uttara Kannada",
  "581327": "Uttara Kannada",
  "581332": "Uttara Kannada",
  "581334": "Uttara Kannada",
  "581343": "Uttara Kannada",
  "581355": "Uttara Kannada",
  "581359": "Uttara Kannada",
  "581401": "Uttara Kannada",
  "582102": "Gadag",
  "582120": "Gadag",
  "583101": "Bellary",
  "583102": "Bellary",
  "583120": "Bellary",
  "583123": "Bellary",
  "583126": "Bellary",
  "583132": "Bellary",
  "583201": "Bellary",
  "583203": "Bellary",
  "583234": "Koppal",
  "584101": "Raichur",
  "584103": "Raichur",
  "584122": "Raichur",
  "584124": "Raichur",
  "584128": "Raichur",
  "585102": "Gulbarga",
  "585103": "Gulbarga",
  "585105": "Gulbarga",
  "585401": "Bidar",
  "586108": "Bijapur(KAR)",
  "586208": "Bijapur(KAR)",
  "586212": "Bijapur(KAR)",
  "586215": "Bijapur(KAR)",
  "587103": "Bagalkot",
  "587125": "Bagalkot",
  "590005": "Belgaum",
  "590006": "Belgaum",
  "590008": "Belgaum",
  "590010": "Belgaum",
  "590017": "Belgaum",
  "590019": "Belgaum",
  "591102": "Belgaum",
  "591201": "Belgaum",
  "591304": "Belgaum",
  "591306": "Belgaum",
  "600004": "Chennai",
  "600005": "Chennai",
  "600007": "Chennai",
  "600010": "Chennai",
  "600011": "Chennai",
  "600012": "Chennai",
  "600013": "Chennai",
  "600014": "Chennai",
  "600015": "Chennai",
  "600016": "Kanchipuram",
  "600017": "Chennai",
  "600018": "Chennai",
  "600019": "Tiruvallur",
  "600020": "Chennai",
  "600021": "Chennai",
  "600023": "Chennai",
  "600024": "Chennai",
  "600026": "Chennai",
  "600028": "Chennai",
  "600029": "Chennai",
  "600031": "Chennai",
  "600032": "Chennai",
  "600033": "Chennai",
  "600034": "Chennai",
  "600035": "Chennai",
  "600037": "Tiruvallur",
  "600040": "Chennai",
  "600041": "Chennai",
  "600042": "Chennai",
  "600043": "Kanchipuram",
  "600044": "Kanchipuram",
  "600045": "Kanchipuram",
  "600048": "Kanchipuram",
  "600049": "Tiruvallur",
  "600050": "Tiruvallur",
  "600052": "Tiruvallur",
  "600053": "Tiruvallur",
  "600054": "Tiruvallur",
  "600056": "Chennai",
  "600058": "Tiruvallur",
  "600059": "Kanchipuram",
  "600060": "Tiruvallur",
  "600061": "Kanchipuram",
  "600062": "Tiruvallur",
  "600063": "Kanchipuram",
  "600064": "Kanchipuram",
  "600069": "Kanchipuram",
  "600070": "Kanchipuram",
  "600071": "Tiruvallur",
  "600073": "Kanchipuram",
  "600075": "Kanchipuram",
  "600076": "Tiruvallur",
  "600077": "Tiruvallur",
  "600078": "Chennai",
  "600080": "CHENNAI",
  "600081": "Chennai",
  "600082": "Chennai",
  "600083": "Chennai",
  "600084": "Chennai",
  "600085": "Chennai",
  "600086": "Chennai",
  "600087": "Tiruvallur",
  "600088": "Kanchipuram",
  "600089": "Chennai",
  "600090": "Chennai",
  "600091": "Kanchipuram",
  "600092": "Chennai",
  "600093": "Chennai",
  "600094": "Chennai",
  "600095": "Tiruvallur",
  "600096": "Kanchipuram",
  "600097": "Kanchipuram",
  "600100": "Kanchipuram",
  "600101": "Chennai",
  "600102": "Chennai",
  "600106": "Chennai",
  "600107": "Chennai",
  "600109": "Chennai",
  "600113": "Chennai",
  "600115": "Kanchipuram",
  "600116": "Kanchipuram",
  "600117": "Kanchipuram",
  "600118": "Chennai",
  "600119": "Chennai",
  "600122": "Kanchipuram",
  "600123": "Tiruvallur",
  "600124": "Tiruvallur",
  "600125": "Kanchipuram",
  "600126": "Kanchipuram",
  "600127": "Kanchipuram",
  "600128": "Tiruvallur",
  "600129": "Kanchipuram",
  "600130": "Kanchipuram",
  "601206": "Tiruvallur",
  "601301": "Kanchipuram",
  "602002": "Tiruvallur",
  "602105": "Kanchipuram",
  "603002": "Kanchipuram",
  "603004": "Kanchipuram",
  "603101": "Kanchipuram",
  "603103": "Kanchipuram",
  "603104": "Kanchipuram",
  "603110": "Kanchipuram",
  "603112": "Kanchipuram",
  "603127": "Kanchipuram",
  "603202": "Kanchipuram",
  "603203": "Kanchipuram",
  "603204": "Kanchipuram",
  "603209": "Kanchipuram",
  "603306": "Kanchipuram",
  "604407": "Tiruvannamalai",
  "605001": "Pondicherry",
  "605003": "Pondicherry",
  "605004": "Pondicherry",
  "605005": "Pondicherry",
  "605006": "Pondicherry",
  "605007": "Pondicherry",
  "605008": "Pondicherry",
  "605009": "Pondicherry",
  "605013": "Pondicherry",
  "605602": "Villupuram",
  "606106": "Cuddalore",
  "606601": "Tiruvannamalai",
  "606701": "Tiruvannamalai",
  "607001": "Cuddalore",
  "607002": "Cuddalore",
  "607205": "Cuddalore",
  "607402": "Pondicherry",
  "607802": "Cuddalore",
  "607803": "Neyveli",
  "608001": "Cuddalore",
  "609110": "Nagapattinam",
  "609501": "Tiruvarur",
  "609602": "Karaikal",
  "609609": "Karaikal",
  "610104": "Tiruvarur",
  "612001": "Thanjavur",
  "612603": "Thanjavur",
  "612702": "Thanjavur",
  "613007": "Thanjavur",
  "613009": "Thanjavur",
  "613501": "Thanjavur",
  "614001": "Tiruvarur",
  "614703": "Tiruvarur",
  "614802": "Thanjavur",
  "620001": "Tiruchirappalli",
  "620006": "Tiruchirappalli",
  "620008": "Tiruchirappalli",
  "620017": "Tiruchirappalli",
  "620019": "Tiruchirappalli",
  "620020": "Tiruchirappalli",
  "620102": "Tiruchirappalli",
  "621010": "Tiruchirappalli",
  "621012": "Tiruchirappalli",
  "621112": "Tiruchirappalli",
  "621212": "Perambalur",
  "621601": "Tiruchirappalli",
  "621715": "Ariyalur",
  "622003": "Pudukkottai",
  "622515": "Pudukkottai",
  "623504": "Ramanathapuram",
  "623517": "Ramanathapuram",
  "624001": "Dindigul",
  "624003": "Dindigul",
  "624005": "Dindigul",
  "624202": "Dindigul",
  "624301": "Dindigul",
  "624302": "Dindigul",
  "624601": "Dindigul",
  "624620": "Dindigul",
  "624709": "Dindigul",
  "625001": "Madurai",
  "625002": "Madurai",
  "625003": "Madurai",
  "625005": "Madurai",
  "625006": "Madurai",
  "625007": "Madurai",
  "625009": "Madurai",
  "625010": "Madurai",
  "625014": "Madurai",
  "625016": "Madurai",
  "625017": "Madurai",
  "625019": "Madurai",
  "625020": "Madurai",
  "625107": "Madurai",
  "625513": "Theni",
  "625601": "Theni",
  "625706": "Madurai",
  "626001": "Virudhunagar",
  "626005": "Virudhunagar",
  "626101": "Virudhunagar",
  "626117": "Virudhunagar",
  "626123": "Virudhunagar",
  "626124": "Virudhunagar",
  "626189": "Virudhunagar",
  "626204": "Virudhunagar",
  "627001": "Tirunelveli",
  "627002": "Tirunelveli",
  "627007": "Tirunelveli",
  "627011": "Tirunelveli",
  "627357": "Tirunelveli",
  "627453": "Tirunelveli",
  "627719": "Tirunelveli",
  "627751": "Tirunelveli",
  "627806": "Tirunelveli",
  "627808": "Tirunelveli",
  "628001": "Tuticorin",
  "628003": "Tuticorin",
  "628004": "Tuticorin",
  "628008": "Tuticorin",
  "628219": "Tuticorin",
  "628501": "Tuticorin",
  "629001": "Kanyakumari",
  "629002": "Kanyakumari",
  "629004": "Kanyakumari",
  "629302": "Kanyakumari",
  "629702": "Kanyakumari",
  "629704": "Kanyakumari",
  "630001": "Sivaganga",
  "630002": "Sivaganga",
  "630103": "Sivaganga",
  "631501": "Kanchipuram",
  "631502": "Kanchipuram",
  "632002": "Vellore",
  "632004": "Vellore",
  "632006": "Vellore",
  "632007": "Vellore",
  "632009": "Vellore",
  "632014": "Vellore",
  "632101": "Vellore",
  "632404": "Vellore",
  "632512": "Tiruvannamalai",
  "632515": "Vellore",
  "632517": "Vellore",
  "632602": "Vellore",
  "635001": "Krishnagiri",
  "635109": "Krishnagiri",
  "635110": "Krishnagiri",
  "635114": "Krishnagiri",
  "635126": "Krishnagiri",
  "635202": "Dharmapuri",
  "635802": "Vellore",
  "636004": "Salem",
  "636007": "Salem",
  "636008": "Salem",
  "636009": "Salem",
  "636010": "Salem",
  "636016": "Salem",
  "636202": "Namakkal",
  "636401": "Salem",
  "636455": "Salem",
  "636705": "Dharmapuri",
  "636810": "Dharmapuri",
  "637209": "Namakkal",
  "637211": "Namakkal",
  "637403": "Namakkal",
  "637408": "Namakkal",
  "638001": "Erode",
  "638002": "Erode",
  "638004": "Erode",
  "638009": "Erode",
  "638011": "Erode",
  "638052": "Erode",
  "638056": "Erode",
  "638107": "Erode",
  "638183": "Namakkal",
  "638301": "Erode",
  "638401": "Erode",
  "638452": "Erode",
  "638701": "Erode",
  "639001": "Karur",
  "639002": "Karur",
  "639004": "Karur",
  "639006": "Karur",
  "639205": "Karur",
  "641001": "Coimbatore",
  "641002": "Coimbatore",
  "641004": "Coimbatore",
  "641005": "Coimbatore",
  "641006": "Coimbatore",
  "641007": "Coimbatore",
  "641013": "Coimbatore",
  "641015": "Coimbatore",
  "641016": "Coimbatore",
  "641020": "Coimbatore",
  "641021": "Coimbatore",
  "641023": "Coimbatore",
  "641025": "Coimbatore",
  "641026": "Coimbatore",
  "641028": "Coimbatore",
  "641029": "Coimbatore",
  "641030": "Coimbatore",
  "641033": "Coimbatore",
  "641035": "Coimbatore",
  "641037": "Coimbatore",
  "641041": "Coimbatore",
  "641042": "Coimbatore",
  "641045": "Coimbatore",
  "641048": "Coimbatore",
  "641049": "Coimbatore",
  "641050": "Coimbatore",
  "641062": "Coimbatore",
  "641109": "Coimbatore",
  "641111": "Coimbatore",
  "641301": "Coimbatore",
  "641302": "Coimbatore",
  "641401": "Coimbatore",
  "641601": "Coimbatore",
  "641602": "Coimbatore",
  "641603": "Coimbatore",
  "641604": "Coimbatore",
  "641605": "Tiruppur",
  "641652": "Coimbatore",
  "641654": "Coimbatore",
  "641659": "Coimbatore",
  "641687": "Coimbatore",
  "642112": "Coimbatore",
  "642126": "Coimbatore",
  "643001": "Nilgiris",
  "670001": "Kannur",
  "670002": "Kannur",
  "670005": "Kannur",
  "670309": "Kannur",
  "670562": "Kannur",
  "670663": "Kannur",
  "670672": "Kannur",
  "670675": "Kannur",
  "670676": "Kannur",
  "670721": "Wayanad",
  "671121": "Kasargod",
  "671321": "Kasargod",
  "671323": "Kasargod",
  "673002": "Kozhikode",
  "673005": "Kozhikode",
  "673006": "Kozhikode",
  "673010": "Kozhikode",
  "673014": "Kozhikode",
  "673017": "Kozhikode",
  "673102": "Kozhikode",
  "673503": "Kozhikode",
  "673507": "Kozhikode",
  "673528": "Kozhikode",
  "673571": "Kozhikode",
  "673601": "Kozhikode",
  "673611": "Kozhikode",
  "676503": "Malappuram",
  "678001": "Palakkad",
  "678002": "Palakkad",
  "678006": "Palakkad",
  "678012": "Palakkad",
  "678014": "Palakkad",
  "678508": "Palakkad",
  "679102": "Palakkad",
  "679103": "Palakkad",
  "679322": "Malappuram",
  "679326": "Malappuram",
  "679328": "Malappuram",
  "679503": "Palakkad",
  "679576": "Malappuram",
  "680002": "Thrissur",
  "680004": "Thrissur",
  "680011": "Thrissur",
  "680013": "Thrissur",
  "680101": "Thrissur",
  "680301": "Thrissur",
  "680307": "Thrissur",
  "680308": "Thrissur",
  "680310": "Thrissur",
  "680562": "Thrissur",
  "680581": "Thrissur",
  "680596": "Thrissur",
  "680623": "Thrissur",
  "680664": "Thrissur",
  "682002": "Ernakulam",
  "682005": "Ernakulam",
  "682011": "Ernakulam",
  "682015": "Ernakulam",
  "682017": "Ernakulam",
  "682018": "Ernakulam",
  "682020": "Ernakulam",
  "682024": "Ernakulam",
  "682030": "Ernakulam",
  "682037": "Ernakulam",
  "682301": "Ernakulam",
  "682306": "Ernakulam",
  "682311": "Ernakulam",
  "682505": "Ernakulam",
  "682509": "Ernakulam",
  "683101": "Ernakulam",
  "683104": "Ernakulam",
  "683106": "Ernakulam",
  "683108": "Ernakulam",
  "683513": "Ernakulam",
  "683542": "Ernakulam",
  "683546": "Ernakulam",
  "683572": "Ernakulam",
  "683574": "Ernakulam",
  "683576": "Ernakulam",
  "685565": "Idukki",
  "685584": "Idukki",
  "685608": "Idukki",
  "685609": "Idukki",
  "686001": "Kottayam",
  "686004": "Kottayam",
  "686006": "Kottayam",
  "686010": "Kottayam",
  "686019": "Kottayam",
  "686020": "Kottayam",
  "686141": "Kottayam",
  "686503": "Kottayam",
  "686508": "Kottayam",
  "686513": "Kottayam",
  "686573": "Kottayam",
  "686574": "Kottayam",
  "686603": "Kottayam",
  "686605": "Kottayam",
  "686635": "Kottayam",
  "686664": "Ernakulam",
  "688003": "Alappuzha",
  "688534": "Alappuzha",
  "688539": "Alappuzha",
  "689101": "Pathanamthitta",
  "689121": "Alappuzha",
  "689501": "Pathanamthitta",
  "689581": "Pathanamthitta",
  "689622": "Alappuzha",
  "689641": "Pathanamthitta",
  "689643": "Pathanamthitta",
  "689646": "Pathanamthitta",
  "690102": "Alappuzha",
  "690510": "Alappuzha",
  "690524": "Kollam",
  "690525": "Kollam",
  "690531": "Alappuzha",
  "690559": "Alappuzha",
  "691001": "Kollam",
  "691002": "Kollam",
  "691003": "Kollam",
  "691015": "Kollam",
  "691020": "Kollam",
  "691303": "Kollam",
  "691306": "Kollam",
  "691333": "Kollam",
  "691510": "Kollam",
  "695002": "Thiruvananthapuram",
  "695003": "Thiruvananthapuram",
  "695004": "Thiruvananthapuram",
  "695006": "Thiruvananthapuram",
  "695009": "Thiruvananthapuram",
  "695010": "Thiruvananthapuram",
  "695011": "Thiruvananthapuram",
  "695013": "Thiruvananthapuram",
  "695015": "Thiruvananthapuram",
  "695017": "Thiruvananthapuram",
  "695020": "Thiruvananthapuram",
  "695023": "Thiruvananthapuram",
  "695030": "Thiruvananthapuram",
  "695036": "Thiruvananthapuram",
  "695301": "Thiruvananthapuram",
  "695305": "Thiruvananthapuram",
  "695547": "Thiruvananthapuram",
  "695564": "Thiruvananthapuram",
  "695573": "Thiruvananthapuram",
  "695582": "Thiruvananthapuram",
  "695583": "Thiruvananthapuram",
  "695604": "Thiruvananthapuram",
  "700004": "Kolkata",
  "700007": "Kolkata",
  "700008": "Kolkata",
  "700010": "Kolkata",
  "700014": "Kolkata",
  "700015": "Kolkata",
  "700017": "Kolkata",
  "700019": "Kolkata",
  "700020": "Kolkata",
  "700026": "Kolkata",
  "700027": "Kolkata",
  "700029": "Kolkata",
  "700031": "Kolkata",
  "700032": "Kolkata",
  "700034": "Kolkata",
  "700038": "Kolkata",
  "700039": "South 24 Parganas",
  "700040": "Kolkata",
  "700042": "Kolkata",
  "700046": "Kolkata",
  "700047": "Kolkata",
  "700051": "North 24 Parganas",
  "700052": "Kolkata",
  "700053": "Kolkata",
  "700054": "Kolkata",
  "700055": "North 24 Parganas",
  "700056": "North 24 Parganas",
  "700059": "North 24 Parganas",
  "700063": "Kolkata",
  "700064": "North 24 Parganas",
  "700067": "Kolkata",
  "700070": "South 24 Parganas",
  "700073": "Kolkata",
  "700074": "Kolkata",
  "700075": "Kolkata",
  "700078": "Kolkata",
  "700082": "Kolkata",
  "700083": "North 24 Parganas",
  "700089": "Kolkata",
  "700091": "North 24 Parganas",
  "700094": "Kolkata",
  "700104": "South 24 Parganas",
  "700105": "South 24 Parganas",
  "700106": "BIDHAN NAGAR",
  "700107": "Kolkata",
  "700108": "Kolkata",
  "700122": "North 24 Parganas",
  "700132": "North 24 Parganas",
  "700135": "North 24 Parganas",
  "700136": "North 24 Parganas",
  "700143": "South 24 Parganas",
  "700151": "South 24 Parganas",
  "700156": "North 24 Parganas",
  "700160": "Kolkata East",
  "711106": "Howrah",
  "711109": "Howrah",
  "711202": "Howrah",
  "711303": "Howrah",
  "712136": "Hooghly",
  "712203": "Hooghly",
  "712221": "Hooghly",
  "712222": "Hooghly",
  "712258": "Hooghly",
  "713102": "Bardhaman",
  "713205": "Durgapur",
  "713209": "Bardhaman",
  "713212": "Bardhaman",
  "713216": "Bardhaman",
  "713325": "Bardhaman",
  "713386": "Bardhaman",
  "721101": "West Midnapore",
  "721301": "West Midnapore",
  "721302": "West Midnapore",
  "721306": "West Midnapore",
  "721424": "West Midnapore",
  "723101": "Puruliya",
  "723102": "Puruliya",
  "723145": "Puruliya",
  "731233": "Birbhum",
  "731302": "Birbhum",
  "732101": "Malda",
  "732128": "Malda",
  "732141": "Malda",
  "733134": "North Dinajpur",
  "733202": "North Dinajpur",
  "734001": "Siliguri",
  "734002": "Darjeeling",
  "734004": "Darjiling",
  "734005": "Darjiling",
  "734008": "Darjiling",
  "734009": "Darjiling",
  "734010": "Darjiling",
  "735215": "Jalpaiguri",
  "736101": "Cooch Behar",
  "736135": "Cooch Behar",
  "737102": "East Sikkim",
  "737132": "East Sikkim",
  "741246": "Nadia",
  "742101": "Murshidabad",
  "742103": "Murshidabad",
  "742140": "Murshidabad",
  "742223": "Murshidabad",
  "744101": "South Andaman",
  "751001": "Bhubaneswar",
  "751002": "Khorda",
  "751003": "Khorda",
  "751006": "Khorda",
  "751007": "Khorda",
  "751010": "Khorda",
  "751012": "Khorda",
  "751013": "Khorda",
  "751014": "Khorda",
  "751015": "Khorda",
  "751016": "Khorda",
  "751017": "Khorda",
  "751022": "Khorda",
  "751024": "Khorda",
  "751029": "Khordha",
  "751030": "Khorda",
  "752002": "Puri",
  "752050": "Khorda",
  "752084": "Nayagarh",
  "752101": "Khorda",
  "753008": "Cuttack",
  "753013": "Cuttack",
  "753014": "Cuttack",
  "753015": "Cuttack",
  "754006": "Cuttack",
  "755019": "Jajapur",
  "756001": "Baleswar",
  "757032": "Mayurbhanj",
  "758001": "Kendujhar",
  "758029": "Kendujhar",
  "759001": "Dhenkanal",
  "759100": "Angul",
  "759121": "Dhenkanal",
  "759128": "Angul",
  "760001": "Ganjam",
  "760008": "Ganjam",
  "761045": "Ganjam",
  "761104": "Ganjam",
  "761200": "Gajapati",
  "762103": "Kandhamal",
  "764001": "Koraput",
  "764020": "Koraput",
  "764071": "Nabarangapur",
  "765001": "Rayagada",
  "765017": "Rayagada",
  "766001": "Kalahandi",
  "767001": "Balangir",
  "767019": "Sonapur",
  "767030": "Balangir",
  "767033": "Balangir",
  "767039": "Balangir",
  "768004": "Sambalpur",
  "768005": "Sambalpur",
  "768006": "Sambalpur",
  "768018": "Sambalpur",
  "768028": "Bargarh",
  "768034": "Bargarh",
  "768108": "Debagarh",
  "768201": "Jharsuguda",
  "768202": "Jharsuguda",
  "768211": "Jharsuguda",
  "768218": "Jharsuguda",
  "769004": "Sundergarh",
  "769005": "Sundergarh",
  "769012": "Sundergarh",
  "769015": "Sundergarh",
  "781001": "Kamrup",
  "781005": "Kamrup",
  "781006": "Kamrup",
  "781008": "Kamrup",
  "781009": "Kamrup",
  "781011": "Kamrup",
  "781017": "Kamrup",
  "781021": "Kamrup",
  "781027": "Kamrup",
  "781036": "Kamrup",
  "781039": "Kamrup",
  "781101": "Kamrup",
  "781335": "Nalbari",
  "783370": "Kokrajhar",
  "783380": "Bongaigaon",
  "783385": "Bongaigaon",
  "784001": "Sonitpur",
  "784028": "Sonitpur",
  "784145": "Darrang",
  "784505": "Sonitpur",
  "784521": "Darrang",
  "785001": "Jorhat",
  "785621": "Golaghat",
  "785670": "Sibsagar",
  "785680": "Sibsagar",
  "786002": "Dibrugarh",
  "786003": "Dibrugarh",
  "786101": "Dibrugarh",
  "786102": "Dibrugarh",
  "786103": "Dibrugarh",
  "786125": "Tinsukia",
  "786602": "Dibrugarh",
  "787051": "Lakhimpur",
  "788001": "Cachar",
  "788002": "Cachar",
  "788003": "Cachar",
  "788005": "Cachar",
  "788007": "Cachar",
  "788127": "Cachar",
  "788151": "Cachar",
  "788931": "North Cachar Hills",
  "792104": "Papum Pare",
  "793001": "East Khasi Hills",
  "793014": "East Khasi Hills",
  "793150": "Jaintia Hills",
  "795001": "Imphal West",
  "795004": "Imphal West",
  "795134": "Bishnupur",
  "797001": "Kohima",
  "797112": "Dimapur",
  "798621": "Mon",
  "799001": "West Tripura",
  "799004": "West Tripura",
  "799009": "West Tripura",
  "799014": "West Tripura",
  "799155": "South Tripura",
  "799277": "North Tripura",
  "800001": "Patna",
  "800002": "Patna",
  "800008": "Patna",
  "800010": "Patna",
  "800013": "Patna",
  "800014": "Patna",
  "800020": "Patna",
  "800023": "Patna",
  "802101": "Buxar",
  "802301": "Bhojpur",
  "805103": "Nawada",
  "811202": "Munger",
  "811212": "Munger",
  "811311": "Lakhisarai",
  "812001": "Bhagalpur",
  "812005": "Bhagalpur",
  "813213": "Bhagalpur",
  "814112": "Deoghar",
  "815301": "Giridh",
  "815354": "Jamtara",
  "822114": "Garhwa",
  "823001": "Gaya",
  "823003": "Gaya",
  "824118": "Gaya",
  "824303": "Aurangabad(BH)",
  "825301": "Hazaribag",
  "826004": "Dhanbad",
  "826007": "Dhanbad",
  "828116": "Dhanbad",
  "828127": "Dhanbad",
  "828202": "Dhanbad",
  "829122": "Ramgarh",
  "831001": "East Singhbhum",
  "831002": "East Singhbhum",
  "831004": "East Singhbhum",
  "831011": "East Singhbhum",
  "831012": "East Singhbhum",
  "831013": "West Singhbhum",
  "831017": "East Singhbhum",
  "832101": "East Singhbhum",
  "833201": "West Singhbhum",
  "834001": "Ranchi",
  "834002": "Ranchi",
  "834003": "Ranchi",
  "834004": "Ranchi",
  "834005": "Ranchi",
  "834006": "Ranchi",
  "834008": "Ranchi",
  "834009": "Ranchi",
  "835101": "Ranchi",
  "835210": "Ranchi",
  "835217": "Ranchi",
  "835222": "Ranchi",
  "842001": "Muzaffarpur",
  "842002": "Muzaffarpur",
  "843319": "Sitamarhi",
  "844101": "Vaishali",
  "844506": "Vaishali",
  "845305": "East Champaran",
  "845401": "East Champaran",
  "845429": "East Champaran",
  "846004": "Darbhanga",
  "847212": "Madhubani",
  "847223": "Madhubani",
  "848125": "Samastipur",
  "851101": "Begusarai",
  "851117": "Begusarai",
  "851204": "Khagaria",
  "852131": "Supaul",
  "852201": "Saharsa",
  "853204": "Bhagalpur",
  "854105": "Katihar",
  "854301": "Purnia",
  "854305": "Purnia",
  "855107": "Kishanganj"
};


